
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novinky",
      function () {
        return require("private-next-pages/novinky/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novinky"])
      });
    }
  